/* tslint:disable */
/* eslint-disable */
/**
 * LPPSWebApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const SimulationSettingsType = {
    CalculationSettings: 'CalculationSettings'
} as const;
export type SimulationSettingsType = typeof SimulationSettingsType[keyof typeof SimulationSettingsType];


export function instanceOfSimulationSettingsType(value: any): boolean {
    for (const key in SimulationSettingsType) {
        if (Object.prototype.hasOwnProperty.call(SimulationSettingsType, key)) {
            if (SimulationSettingsType[key as keyof typeof SimulationSettingsType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function SimulationSettingsTypeFromJSON(json: any): SimulationSettingsType {
    return SimulationSettingsTypeFromJSONTyped(json, false);
}

export function SimulationSettingsTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): SimulationSettingsType {
    return json as SimulationSettingsType;
}

export function SimulationSettingsTypeToJSON(value?: SimulationSettingsType | null): any {
    return value as any;
}

export function SimulationSettingsTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): SimulationSettingsType {
    return value as SimulationSettingsType;
}

